import { render } from "./DeepAnalysis.vue?vue&type=template&id=5057a81e&scoped=true"
import script from "./DeepAnalysis.vue?vue&type=script&lang=js"
export * from "./DeepAnalysis.vue?vue&type=script&lang=js"

import "./DeepAnalysis.vue?vue&type=style&index=0&id=5057a81e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5057a81e"]])

export default __exports__